import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'

import { ImageWrapper } from './styles'

type Props = {
  name: string
  imageUrl: string
  isDark?: boolean
}

export const CardSimple: React.FC<Props> = ({ name, imageUrl, isDark = false }) => {
  return (
    <Box marginBottom="10px">
      <Flex>
        <ImageWrapper>
          <img src={imageUrl} alt="" />
        </ImageWrapper>

        <Flex marginLeft="16px" alignItems="center">
          <Text color={isDark ? 'black' : 'white'} fontSize="sm" fontWeight={600} lineHeight="18px">
            {name}
          </Text>
        </Flex>
      </Flex>
    </Box>
  )
}
